import { useQuery } from "@tanstack/react-query";
import { getNavIndicators } from "@/features/indicators/indicators.api";
import type { NavIndicators } from "@/features/indicators/schemas/indicators.schema";

const STALE_MS = 60_000;
const REFETCH_MS = 60_000;

export function useNavIndicators(workspaceId: string | undefined) {
  return useQuery<NavIndicators>({
    queryKey: ["nav-indicators", workspaceId],
    queryFn: () => {
      if (!workspaceId) {
        throw new Error("workspaceId is required");
      }
      return getNavIndicators(workspaceId);
    },
    enabled: Boolean(workspaceId),
    staleTime: STALE_MS,
    refetchInterval: REFETCH_MS,
    refetchIntervalInBackground: false,
    retry: 1,
  });
}
